import { ClockIcon } from "../../../assets/ClockIcon";

export default function TimePickerStep({
  selectedDate,
  selectedTime,
  availableSlots,
  formatDate,
  formatSlot2h,
  onSelectTime,
  onBackToDate,
}: {
  selectedDate: Date;
  selectedTime: string | null;
  availableSlots: string[];
  formatDate: (d: Date) => string;
  formatSlot2h: (t: string) => string;
  onSelectTime: (t: string) => void;
  onBackToDate: () => void;
}) {
  return (
    <div>
      <p className="tdb-timeTitle">
        <ClockIcon className="tdb-timeIcon" />
        {formatDate(selectedDate)} — Choisissez un créneau
      </p>

      <div className="tdb-timeGrid">
        {availableSlots.map((t) => (
          <button
            type="button"
            key={t}
            onClick={() => onSelectTime(t)}
            className={`tdb-slotBtn ${selectedTime === t ? "is-selected" : ""}`}
          >
            {formatSlot2h(t)}
          </button>
        ))}
      </div>

      <button type="button" onClick={onBackToDate} className="tdb-linkBtn">
        ← Changer la date
      </button>
    </div>
  );
}
